import axios from 'axios';
// config
import { HOST_API } from 'src/config-global';

// ----------------------------------------------------------------------

const axiosInstance = axios.create({ baseURL: HOST_API });

axiosInstance.interceptors.request.use(
  (config) => {
    const token = sessionStorage.getItem('accessToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

axiosInstance.interceptors.response.use(
  (res) => res,
  (error) => Promise.reject((error.response && error.response.data) || 'Something went wrong')
);

export default axiosInstance;

// ----------------------------------------------------------------------
// GET Fetcher (DEFAULT)
// ----------------------------------------------------------------------
export const fetcher = async (args) => {
  const [url, config] = Array.isArray(args) ? args : [args];

  const res = await axiosInstance.get(url, { ...config });

  return res.data;
};

// ----------------------------------------------------------------------
// POST Fetcher
// ----------------------------------------------------------------------

export const postFetcher = async (args) => {
  const [url, data, config] = Array.isArray(args) ? args : [args];

  const res = await axiosInstance.post(url, data, { ...config });

  return res.data;
};
// ----------------------------------------------------------------------
// PUT Fetcher
// ----------------------------------------------------------------------

export const putFetcher = async (args) => {
  const [url, data, config] = Array.isArray(args) ? args : [args];

  const res = await axiosInstance.put(url, data, { ...config });

  return res.data;
};

// ----------------------------------------------------------------------
// PATCH Fetcher
// ----------------------------------------------------------------------

export const patchFetcher = async (args) => {
  const [url, data, config] = Array.isArray(args) ? args : [args];

  const res = await axiosInstance.patch(url, data, { ...config });

  return res.data;
};

// ----------------------------------------------------------------------
// DELETE Fetcher
// ----------------------------------------------------------------------

export const deleteFetcher = async (args) => {
  const [url, config] = Array.isArray(args) ? args : [args];

  const res = await axiosInstance.delete(url, { ...config });

  return res.data;
};

// ----------------------------------------------------------------------

export const endpoints = {

  chat: '/api/chat',
  kanban: '/api/kanban',
  calendar: '/api/calendar',
  auth: {
    get me() {
      const queryParam = sessionStorage.getItem('type');
      return queryParam ? `/accounts/api/me/?type=${queryParam}` : '/accounts/api/me/';
    },
    login: '/accounts/api/login/',
    thelogin: '/accounts/api/thelogin/',
    logout: '/accounts/api/logout/',
    register: '/api/auth/register',
    emailVerification: {
      sendOtp: '/accounts/api/email-verification/send-otp/',
      verifyOtp: '/accounts/api/email-verification/verify-otp/',
      updateEmail: '/accounts/api/email-verification/update-email/',
    },
  },
  mail: {
    list: '/api/mail/list',
    details: '/api/mail/details',
    labels: '/api/mail/labels',
  },
  post: {
    list: '/api/post/list',
    details: '/api/post/details',
    latest: '/api/post/latest',
    search: '/api/post/search',
  },
  product: {
    list: '/api/product/list',
    details: '/api/product/details',
    search: '/api/product/search',
  },
};
